<template>
  <FaqList :items="items" />
</template>

<script>
import FaqList from '@/components/Faq/FaqList.vue'
import { getPrivacyPagePath } from '@/helpers/url'

export default {
  name: 'FaqSecurity',
  components: {
    FaqList,
  },

  computed: {
    privacyPageUrl() {
      return getPrivacyPagePath(this.$i18n.locale)
    },

    items() {
      return [...Array(5)].map((_, index) => ({
        question: this.$t(`item${index + 1}.question`),
        answer: this.$t(`item${index + 1}.answer`, { privacyPageUrl: this.privacyPageUrl }),
        isAlwaysOpen: index === 0,
      }))
    },
  },
}
</script>

<i18n src="@/locales/faq-security.json" />
